const state = {
  homepage: [],
  get_article: [],
  banner_microsite_id: [],
};

export default state;
